import { css } from 'lit';
import { createSelector } from 'reselect';
import { QueueState, SignDto } from '@typings/api';
import { AppAlert } from '@typings/shared-types';
import ConfigCARSx from '@/config/ConfigCARSx';
import { AppSection, DMSView } from '@/constants';
import { isValidString } from '@/utils/utils';
import { signsSelector } from './dms/dms-selectors';

const selectAlerts = createSelector(signsSelector, (signs: SignDto[]): AppAlert[] => {
	const alerts: AppAlert[] = [];

	signs?.forEach((sign) => {
		const { id, number, currentMessageState, latestMessageLog } = sign;
		if (
			isValidString(sign.ipAddress) &&
			((currentMessageState && [QueueState.ERROR].includes(currentMessageState)) ||
				(latestMessageLog && latestMessageLog.result === 'ERROR'))
		) {
			const timeInMillis =
				latestMessageLog?.actionEnd ??
				latestMessageLog?.updated ??
				latestMessageLog?.created ??
				Date.now();

			alerts.push({
				title: 'DMS message send error',
				category: 'ERROR',
				source: 'DMS module',
				icon: 'img/sprites.svg#icon-warning-fill',
				content: `Sign #${number} failed to post message -- ${currentMessageState ?? latestMessageLog?.result}`,
				timeInMillis,
				actions: [
					{
						actionTitle: 'Retry message',
						icon: 'img/sprites.svg#icon-refresh',
						link: `${ConfigCARSx.Pages[AppSection.DMS].route}/${DMSView['sign-queue']}/${id}`,
					},
				],
			});
		}
	});

	return alerts;
});

export default selectAlerts;
